import React,{useState,useEffect} from "react";
import fireDb from '../../config.js';
import {Link} from "react-router-dom";
import "./Home.css"
import { toast,ToastContainer } from "react-toastify";
const Home = () => {

  const[data,setData] = useState({});

  useEffect(() =>{
    fireDb.child("contacts").on("value",(snapshot)=>{
      if(snapshot.val() !==null){
        setData({...snapshot.val()});
      }else{
        setData({})
      }
    });
    return () =>{
      setData({})
    }
  },[]);

 const onDelete=(id) =>{
  if(window.confirm("Are you sure that you wanted to delete that contact ?")){
    fireDb.child(`contacts/${id}`).remove((err)=>{
      if(err){
        toast.error(err)
      }else{
        toast.success("Contact Deleted Successfully")
      }
    })
  }
 }

  return (
  <div className="container">
   <table className="styled-table">
   <thead>
   <tr>
   <th style={{textAlign:"center"}}>No.</th>
   <th style={{textAlign:"center"}}>Name</th>
   <th style={{textAlign:"center"}}>Email</th>
   <th style={{textAlign:"center"}}>Contact</th>
   <th style={{textAlign:"center"}}>Acttion</th>

   </tr>
   </thead>
   <tbody>
   {Object.keys(data).map((id,index)=>{
    return(
   <tr key={id}>
     <th scope="row">{index +1}</th>
     <td>{data[id].name}</td>
     <td>{data[id].email}</td>
     <td>{data[id].contact}</td>
     <td>
     <div className="buttonContainer">
      <Link to={`/update/${id}`}>
      <button  className=" btn-edit">Edit</button>
      </Link>
       <button   className=" btn-delete" onClick={() => onDelete(id)}>Delete</button>
      <Link to={`/view/${id}`}>
      <button  className=" btn-view">View</button>
      </Link>
      </div>
     </td>
     </tr>
    )
    })}
   </tbody>
   </table>
   <ToastContainer  position="top-center"
   autoClose={2000} />
    </div>
  );
}

export default Home;
